import { PushAdminBoard } from '../../../features/push-admin';

export function PushSettingsPage() {
  return <PushAdminBoard />;
}
